/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, Inject, ViewChild, ElementRef, OnDestroy, OnInit, AfterViewInit } from "@angular/core";
import { saveAs } from "file-saver";
import { MatDialogRef } from "@angular/material/dialog";
import { ApiService } from "@app/@core/services";
import { PageService } from "@auth/services/page";
import { MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog } from "@angular/material/dialog";
import { AdminComplianceService } from "@app/@shared/services/admin/compliance";
import { MessageService } from "@app/@shared/components/message/message.service";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { Subscription, fromEvent } from "rxjs";
import { debounceTime, map, distinctUntilChanged, filter } from "rxjs/operators";
import { AdminProductsAddRidersDialogComponent } from "@app/@shared/components/admin/products-add-riders-dialog/products-add-riders-dialog.component";

import * as Fuse from "fuse.js";

@Component({
  selector: "admin-product-options-tag-riders-dialog",
  templateUrl: "./product-options-tag-riders-dialog.component.html",
  styleUrls: ["./product-options-tag-riders-dialog.component.scss"],
})
export class AdminProductOptionsTagRidersDialogComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild("submissionsDatatable", { static: false }) submissionsDatatable: DatatableComponent;

  private submissions_sub: Subscription;
  private resizeSub: Subscription;
  private postSub: Subscription;
  processing: boolean = false;
  dataLoaded: boolean = false;
  submissions;
  submissions_cache;

  selected: any = [];

  new_options: any = [];

  messages = {
    emptyMessage: "No Riders Records to display.",
    totalMessage: "Riders Records",
  };
  expanded: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private injected_data: any, 
    private _notification: MessageService, 
    private pageService: PageService,
    public apiService: ApiService, 
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AdminProductOptionsTagRidersDialogComponent>) {
      this.resizeSub = this.pageService.windowResize.subscribe(() => setTimeout(() => this.submissionsDatatable && this.submissionsDatatable.recalculate()));
    }

  ngOnInit() {
    this.new_options = this.injected_data.options;
    if (this.injected_data.product_option.riders.length) {
      this.injected_data.product_option.riders.forEach(rider => {
        const selected_rider = this.injected_data.riders.filter(obj => obj.uuid === rider.uuid);
        this.selected.push(...selected_rider);
      });
    }
  }


  ngAfterViewInit() {
    setTimeout(() => this.applyRiders());
  }

  ngOnDestroy() {
    if (this.submissions_sub) this.submissions_sub.unsubscribe();
    if (this.resizeSub) this.resizeSub.unsubscribe();
    if (this.postSub) this.postSub.unsubscribe();
  }

  applyRiders() {
    if (this.injected_data) {
      this.submissions = [...this.injected_data.riders];
      this.submissions_cache = [...this.injected_data.riders];
      setTimeout(() => {
        this.dataLoaded = true;
      }, 1000);
    }
  }

  getDatatableHeight(data, rowHeight) {
    let max_height = 10 * rowHeight;
    let temp_height = (data.length || 1) * rowHeight;
    return temp_height > max_height ? max_height : temp_height;
  }

  checkIntroducer(records) {
    let year = new Date().getFullYear();
    if (records.length > 0) return records.filter((row) => row["year"] == year).length > 0;
    return false;
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    this.processing = true;
    let url = 'admin/product-options/' + this.injected_data.product_option.uuid + '/riders';
    this.postSub = this.apiService.patch(url, {data: JSON.stringify(this.selected)}).subscribe((res) => {
      if (!res.error) this.new_options = res.data;
      this.processing = false;
    });
  } 

  close() {
    this.dialogRef.close(this.new_options);
  }

  newRider() {
    const dialogRef = this.dialog.open(AdminProductsAddRidersDialogComponent, {
      width: "600px",
      disableClose: true,
      data: {
        'provider_slug': this.injected_data.provider_slug
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result["error"] === false) {
        // console.log(result);
        this.submissions = [...result['data']];
        this.submissions_cache = [...result['data']];
      }
    });
  }
}
